// extracted by mini-css-extract-plugin
module.exports = {"ItemList":"Item_ItemList__3mWVG","done":"Item_done__3OcEw","delete":"Item_delete__zJqjE"};